

import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Text } from './Text';

export const AutoSizingTextSettings = (text: Text) => ({
    fontFamily: text.fontFamily,
    fontColor: text.fontColor,
    fontSize: 0, // Enables auto-sizing
    fontStyle: text.fontStyle,
    fontWeight: text.fontWeight,
    lineHeight: 1.25,
    maxFontSize: text.fontSize,
    textAlignV: text.textAlignV,
    textMargin: 2,
    textAlignH: text.textAlignH,
});

export const TextLayout = (text: Text) => {

    const base = new Rect(0, 0, text.width, text.height);

    const autoSettings = AutoSizingTextSettings(text);

    const managedFontSize = text.autoHeight
        ? text.fontSize
        : Math.min(
            autoSettings.maxFontSize,
            TextRuler.fit(text.content, autoSettings, base.width, base.height),
        );

    const settings = { ...autoSettings, fontSize: managedFontSize };
    const content = { bounds: base, settings, };

    return { base, content };
};

export type TextLayout = ReturnType<typeof TextLayout>;
